import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import CreateIcon from '@material-ui/icons/Create';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SaveIcon from '@material-ui/icons/Save';
import { Grid } from '@material-ui/core';
import Unidadetransporte from '../componentes/unidadetransporte';


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));



     
      //****************************controle atalho cadastrar***************************** */
   
  

 
      var ut='';
  var st=true;
  
export default function RecipeReviewCard(props) {
  const [unidadetransporte, setaunidadetransporte] = React.useState([{ 
    id:'', label:''
  }]);

 
  //
  const [stnome, setanome] = React.useState('');
  const [stmatricula, setamatricula] = React.useState('');
  const [stcnh, setacnh] = React.useState('');
  const [stcatcnh, setacatcnh] = React.useState('');
  const [stcatmotora, setacatmotora] = React.useState([{}]);
  const [strg, setarg] = React.useState('');
  const [stcpf, setacpf] = React.useState('');
  const [sttelefone, setatelefone] = React.useState('');
  const [stemail, setaemail] = React.useState('');
  const [stvenccnh, setavenccnh] = React.useState('');
  const [stid, setaid] = React.useState('');
  const [stcoduni, setacoduni] = React.useState('');

  //****************************************************************carregar tipos veiculo***************** */
const[categoriaMotorista,setacategoriamotorista]=React.useState();

React.useEffect(()=>{
firebase.firestore().collection("categoriasmotorista")
      .get()
      .then(function(querySnapshot) {
        var cats=[];
          querySnapshot.forEach(function(doc) {
            
              cats.push({value: doc.id, label: doc.data().catmotorista});
          });
          setacategoriamotorista(cats);
      })
      .catch(function(error) {
          console.log("Erro ao carregar (tipos de veículos): ", error);
      })
    },[0])
//*******************************salvar edit************ */

const handlesalvar=async ()=>{
    
  var nome = stnome;
  var matricula = stmatricula;
  var cnh = stcnh;
  var catcnh = stcatcnh;
  var catmotora=stcatmotora;
  var rg = strg;
  var cpf =stcpf;
  var telefone = sttelefone;
  var email = stemail;
  var vencimentocnh = stvenccnh;
  var codunidadetransporte = unidadetransporte[0].id;
  var userid=stid
  var user = firebase.firestore().collection("usuarios").doc(userid);
  
  try {

  await user.update({
      nome: nome, matricula:matricula, telefone:telefone, usertipo:'11', codunidadetransporte: codunidadetransporte, cnh:cnh,
      cpf:cpf, categoriaCNH: catcnh, categoriaMotorista:catmotora, email:email, rg:rg,
      vencimentocnh:vencimentocnh});
   
    setedita(true);
    setbotaoedit(false);
    setExpanded(false);

    var query = firebase.firestore().collection("usuarios").doc(userid).get()
                  .then((doc) => {
                    var listausers=[];
                    listausers.push({id: doc.id, nome: doc.data().nome,
                      matricula:doc.data().matricula, telefone: doc.data().telefone, status: doc.data().userstatus,
                    usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadetransporte: doc.data().codunidadetransporte,
                    cnh:doc.data().cnh, cpf:doc.data().cpf, catcnh:doc.data().categoriaCNH, catmotora:doc.data().categoriaMotorista,
                  email:doc.data().email, rg:doc.data().rg, vencimentocnh:doc.data().vencimentocnh });
                  console.log("veiculos pqp ", state );
                    setitemmotora (listausers);
                   
        
                  
                 
                })
               .catch(error => {
                   console.log('Não encontramos veículos cadastrados', error);
               });


  } catch (error_1) {
    var errorMessage = error_1.message;

    alert(errorMessage);
  }




}

//********************objeto veiculo******************* */

const [itemmotora, setitemmotora] = React.useState([]);
var tipo1='';
var unidt2;
const [statecampi,setcampi]=React.useState('');

React.useEffect(()=>{
  setitemmotora(props.props);

},[0])

React.useEffect(()=>{

itemmotora.forEach(modelo=>(st=modelo.status))
setState({...state,checkmanobra:st});
var id;
itemmotora.map(modelo=>(id=modelo.id));
setaid(id);
var nome;
itemmotora.map(modelo=>(nome=modelo.nome));
setanome(nome);
var matricula;
itemmotora.map(modelo=>(matricula=modelo.matricula));
setamatricula(matricula);
var cnh;
itemmotora.map(modelo=>(cnh=modelo.cnh));
setacnh(cnh);
var catcnh;
itemmotora.map(modelo=>(catcnh=modelo.catcnh));
setacatcnh(catcnh);
var rg;
itemmotora.map(modelo=>(rg=modelo.rg));
setarg(rg);
var cpf;
itemmotora.map(modelo=>(cpf=modelo.cpf));
setacpf(cpf);
var email;
itemmotora.map(modelo=>(email=modelo.email));
setaemail(email);
var telefone;
itemmotora.map(modelo=>(telefone=modelo.telefone));
setatelefone(telefone);
var vcnh;
itemmotora.map(modelo=>(vcnh=modelo.vencimentocnh));
setavenccnh(vcnh);
var cmotora;
itemmotora.map(modelo=>(cmotora=modelo.catmotora));
setacatmotora(cmotora);
var unidade;
itemmotora.map(modelo=>(unidade=modelo.codunidadetransporte));
setacoduni(unidade);
var cam;
itemmotora.map(modelo=>(cam=modelo.campi));
setcampi(cam);
var tipo;
itemmotora.map(modelo=>(tipo=modelo.usertipo));
if(tipo==17){
  setState({...state,checkservidor:true});
}



//console.log("validade " , teste)
},[itemmotora]
)




    
  //**************************controle habilita e desabilita */

  const [edita, setedita] = React.useState(true);
  const [botaoedit, setbotaoedit] = React.useState(false);

  const handleeditar=()=>{
    setedita(false);
    setbotaoedit(true);
    setExpanded(true);
    
  }



     //************************************controle interruptor*/
     
  
  const [state, setState] = React.useState({
    checkmanobra:false, checkservidor:false, });

  const handlemanobra = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });

    console.log('val state ', event.target.checked)
    var userid;
    itemmotora.forEach(modelo=>(userid=modelo.id));
    var user = firebase.firestore().collection("usuarios").doc(userid);
    
    return user.update({userstatus:event.target.checked})
    .then(() => {
        console.log("Document successfully updated!");
        console.log ("user id ",userid);
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });
  };


  const handleservidor = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
    var tipos="11";

    console.log(event.target.checked);
    console.log(event.target.checked);
    if(event.target.checked){
      tipos="17";
    }else{
      tipos="11";
    }
    console.log('val state ', event.target.checked)
    var userid;
    itemmotora.forEach(modelo=>(userid=modelo.id));
    var user = firebase.firestore().collection("usuarios").doc(userid);
    
    return user.update({usertipo:tipos})
    .then(() => {
        console.log("Document successfully updated!");
        console.log ("user id ",userid);
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });
  };
 
      //********************************************************************** */


  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
    if(expanded){
    setedita(true);
    setbotaoedit(false)}
  };
  
  //************************************************************* */
  const handlecat=(event, value)=>(
    setacatmotora(value),
    console.log("target ", value)
)

  //**************************************** */
  return (
    <Card className={classes.root} >
     
           <CardHeader
             avatar={
               
               <Avatar aria-label="User" className={classes.avatar}>
                <AccountCircleIcon />
               </Avatar>
             }
            
             title= {stnome}
             subheader= {stmatricula}
     
           />
           <CardContent>
           <Typography variant="body2" color="textSecondary" component="p">
          
        </Typography>
           <Typography variant="body2" color="textSecondary" component="p">
          CNH: {stcnh} Cat: {stcatcnh}
        </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
          Telefone: {sttelefone}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          E-mail: {stemail}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          {unidadetransporte[0].label}
        </Typography>
               
        

      </CardContent>
          
            <CardActions disableSpacing>
           
            <FormGroup row>
            <FormControlLabel
             control={
               <Switch
                 checked={state.checkmanobra}
                 onChange={handlemanobra}
                 name="checkmanobra"
                 color="primary"
               />
             }
             label="Ativo"
           />
           
         </FormGroup>
         <FormGroup row>
            <FormControlLabel
             control={
               <Switch
                 checked={state.checkservidor}
                 onChange={handleservidor}
                 name="checkservidor"
                 color="primary"
               />
             }
             label="Servidor"
           />
           
         </FormGroup>
     
             <IconButton id="btsalvar" aria-label="Salvar" disabled={edita} onClick={handlesalvar} >
               <SaveIcon />
             </IconButton>
             <IconButton id="bteditar" aria-label="Editar" disabled={botaoedit} onClick={handleeditar}>
               <CreateIcon />
             </IconButton>
             <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
     
             
     
           </CardActions>
           <Collapse in={expanded} timeout="auto" unmountOnExit>
             <CardContent>
             
             
            
             <FormControl  fullWidth variant="outlined"  className={classes.formControl}>
               {
               //unidadetransporte.foreach(modelo=>(campiss=modelo.campi))
               }
             <Unidadetransporte requer={true} 
        campi={statecampi} disabled={edita} unidadet={stcoduni} setaunidadetransporte={setaunidadetransporte} />

          
        </FormControl>
     <br></br>
               {console.log("valor catmotora  ",stcatmotora )}
       
         
          <TextField
              variant="outlined"
              margin="normal"
              onChange={ e=>setanome(e.target.value)}
              required
              type="nome"
              fullWidth
              id="nome"
              label="Nome"
              name="nome"
              defaultValue={stnome}
              disabled={edita}
              
            />
            <br></br>

                  <Autocomplete onChange={handlecat}
                   className={classes.formControl}
                    id="combotipo"
                    options={categoriaMotorista}
                    getOptionLabel={(option) => option.label}
                    disabled={edita}
                   value={stcatmotora}
                    getOptionSelected={(option,temp) => option.id==temp.id}
                    renderInput={(params) => <TextField {...params}   required label="Categoria Motorista" variant="outlined" />}
                 
                 />
     
     
                     <TextField
                      
                      variant="outlined"
                      margin="normal"
                      onChange={ e=>setamatricula(e.target.value)}
                      required
                      //type="phoneNumber"
                      fullWidth
                      id="matricula"
                      label="Matrícula"
                      name="matricula"
                      defaultValue={stmatricula}
                      disabled={edita}
                      
                      />   
                
                <TextField
              variant="outlined"
              margin="normal"
              onChange={ e=>setacnh(e.target.value)}
              required
              type="mail"
              fullWidth
              id="cnh"
              label="Habilitação"
              name="cnh"
              defaultValue={stcnh}
              disabled={edita}
              
              
            />        

            <Grid container >
              
              <Grid item>
              <TextField
              variant="outlined"
              margin="normal"
              onChange={ e=>setacatcnh(e.target.value)}
              required
              type=""
              fullWidth
              id="catcnh"
              label="Categoria"
              name="catcnh"
              defaultValue = {stcatcnh}
              disabled={edita}
              />
              </Grid>

              <Grid item>
                        <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        id="vencimentocnh"
                        fullWidth
                        onChange={ e=>setavenccnh(e.target.value)}
                        label="Validade"
                        type="date"
                        name="catcnh"
                        defaultValue={stvenccnh}
                        disabled={edita}
                        className={classes.textField}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
              
              </Grid>
              </Grid>     
                
                
                 
     
            <TextField
              variant="outlined"
              margin="normal"
              onChange={ e=>setarg(e.target.value)}
              required
              type=""
              fullWidth
              id="rg"
              label="Identidade"
              name="rg"
              defaultValue=  {strg}
                 disabled={edita}
            />
     
                
                      
               
   
     
            <TextField
              variant="outlined"
              margin="normal"
              onChange={ e=>setacpf(e.target.value)}
              required
              type="mail"
              fullWidth
              id="cpf"
              label="CPF"
              name="cpf"
              defaultValue=  {stcpf}
              disabled={edita}
              
              
            />

              <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              onChange={ e=>setatelefone(e.target.value)}
              name="telefone"
              label="Telefone"
              type=""
              id="telefone"
              defaultValue={sttelefone}
              disabled={edita}
             />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              onChange={ e=>setaemail(e.target.value)}
              name="email"
              label="E-mail"
              type="email"
              id="email"
              defaultValue={stemail}
              disabled={edita}
            />
     
              
             <Typography component="h7" variant="h10">
           * Preenchimento obrigatório 
          </Typography>
     
          
        
                             
         
     
             </CardContent>
             <CardActions disableSpacing>
           
            <FormGroup row>
            <FormControlLabel
             control={
               <Switch
                 checked={state.checkmanobra}
                 onChange={handlemanobra}
                 name="checkmanobra"
                 color="primary"
               />
             }
             label="Ativo"
           />
           
         </FormGroup>
     
             <IconButton id="btsalvar" aria-label="Salvar" disabled={edita} onClick={handlesalvar}>
               <SaveIcon />
             </IconButton>
             <IconButton id="bteditar" aria-label="Editar" disabled={botaoedit} onClick={handleeditar}>
               <CreateIcon />
             </IconButton>
             <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
     
             
     
           </CardActions>
           </Collapse>
           
         </Card>
  );
}
//form className={classes.form} onSubmit={handlesalvar} noValidate={false}>
  //         </form>